var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon4FerryWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_7",
    "data-name": "Layer 7",
    viewBox: "0.63 1.82 48.14 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.28044,15.07641v-3.7616a40.61676,40.61676,0,0,1,14.418-2.5,40.6169,40.6169,0,0,1,14.418,2.5v3.7616"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.39684,25.52351v-9.3558a44.32308,44.32308,0,0,1,17.30162-3.3529,44.3232,44.3232,0,0,1,17.30162,3.3529v9.3558"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.24164,19.31481a35.72512,35.72512,0,0,1,13.45682-2.5,35.72525,35.72525,0,0,1,13.45682,2.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "20.854 8.985 22.776 2.815 26.621 2.815 28.543 8.985"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.816,43.06841l5.81777-13.3812a2.02774,2.02774,0,0,0-1.01523-2.6736c-4.29589-1.8376-15.10373-6.1988-20.92-6.1988S8.07428,25.176,3.77839,27.01361a2.02774,2.02774,0,0,0-1.01522,2.6736L8.581,43.06861"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 24.69846,
    y1: 41.81481,
    x2: 24.69846,
    y2: 24.81481
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.62963,50.81481c2.47162,0,3.29557-3,5.76721-3s3.29556,3,5.7672,3,3.29557-3,5.76721-3,3.29557,3,5.76721,3,3.29556-3,5.76721-3,3.29556,3,5.7672,3,3.29557-3,5.76721-3,3.29557,3,5.76721,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.62963,45.81481c2.47162,0,3.29557-3,5.76721-3s3.29556,3,5.7672,3,3.29557-3,5.76721-3,3.29557,3,5.76721,3,3.29556-3,5.76721-3,3.29556,3,5.7672,3,3.29557-3,5.76721-3,3.29557,3,5.76721,3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4FerryWhite);
export default __webpack_public_path__ + "static/media/icon_4_ferry_white.870f49179b6019f2b6bb463112e0a19c.svg";
export { ForwardRef as ReactComponent };